// extracted by mini-css-extract-plugin
module.exports = {"section":"Partnerships_section__PonpV","title":"Partnerships_title___Amci","content":"Partnerships_content__NhOoo","image":"Partnerships_image__QeIYW"};